import { Badge, Button } from "@tonic/shared/components/ui";
import { formatDate } from "@/utils/format";

const getStatusColor = (status) => {
  switch (status) {
    case 'RECEIVED':
      return 'default';
    case 'INSPECTING':
      return 'warning';
    case 'PROCESSED':
      return 'success';
    case 'REJECTED':
      return 'destructive';
    default:
      return 'default';
  }
};

const getTypeColor = (type) => {
  switch (type) {
    case 'REPAIR':
      return 'blue';
    case 'REFILL':
      return 'green';
    case 'RESALE':
      return 'purple';
    case 'RECYCLE':
      return 'emerald';
    case 'RETURN':
      return 'orange';
    default:
      return 'default';
  }
};

const getPriorityColor = (priority) => {
  switch (priority) {
    case 'HIGH':
      return 'destructive';
    case 'MEDIUM':
      return 'warning';
    case 'LOW':
      return 'default';
    default:
      return 'default';
  }
};

export const columns = [
  {
    accessorKey: "trackingNumber",
    header: "Tracking #",
  },
  {
    accessorKey: "type",
    header: "Type",
    cell: ({ row }) => (
      <Badge variant={getTypeColor(row.original.type)}>
        {row.original.type}
      </Badge>
    ),
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => (
      <Badge variant={getStatusColor(row.original.status)}>
        {row.original.status}
      </Badge>
    ),
  },
  {
    accessorKey: "priority",
    header: "Priority",
    cell: ({ row }) => (
      <Badge variant={getPriorityColor(row.original.priority)}>
        {row.original.priority}
      </Badge>
    ),
  },
  {
    accessorKey: "customer",
    header: "Customer",
    cell: ({ row }) => (
      <div>
        <div className="font-medium">{row.original.customer.name}</div>
        <div className="text-sm text-muted-foreground">{row.original.customer.email}</div>
      </div>
    ),
  },
  {
    accessorKey: "orderReference",
    header: "Order Ref",
  },
  {
    accessorKey: "receivedAt",
    header: "Received",
    cell: ({ row }) => formatDate(row.original.receivedAt),
  },
  {
    accessorKey: "assignedTo",
    header: "Assigned To",
    cell: ({ row }) => row.original.assignedTo?.name || "Unassigned",
  },
  {
    id: "actions",
    cell: ({ row }) => (
      <Button
        variant="ghost"
        onClick={() => {
          // TODO: Navigate to detail page
          console.log('Navigate to:', row.original.id);
        }}
      >
        View Details
      </Button>
    ),
  },
]; 
